import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"
// Your config
const firebaseConfig = {
  apiKey: "AIzaSyAIK3cmtZXxu7rITK6-XGiFZDG9h_x4FI8",
  authDomain: "qacoder2001.firebaseapp.com",
  projectId: "qacoder2001",
  storageBucket: "qacoder2001.firebasestorage.app",
  messagingSenderId: "77615408244",
  appId: "1:77615408244:web:eb36b2d4184481908ddd21",
};

// Initialize app
const app = initializeApp(firebaseConfig);

// ✅ IMPORTANT LINE (this fixes your error)
export const db = getFirestore(app);
export const auth = getAuth(app);